// featureFlagsPlatform are feature flags enabled on the entire website through the platform
export const featureFlagsPlatform = {
  'platform.design-system-team.brand-refresh-update-product-logos_q7coo': true,
};

// featureFlags are feature flags the the user can enable through localstorage
// These are on the client-side
const featureFlags = {};

export type FeatureFlag = keyof typeof featureFlags;

export default featureFlags;
